const data = {
  home: {
    title: "Hi, I'm Arthur",
    subtitle: "Software Developer",
    description:
      "Skilled in developing both frontend and backend applications, producing quality work.",
  },
  about: {
    description:
      "I'm a software developer who constantly seeks out innovative solutions to everyday problems, working in web technologies and applications, delivering quality work.",
  },
  services: {
    frontend: [
      {
        id: 1,
        desc: "Javascript",
        // desc: "Designing beautiful mobile first website",
      },
      {
        id: 2,
        desc: "ReactJs/NextJs",
        // desc: "Custom Landing pages",
      },
      {
        id: 3,
        desc: "HTML5/CSS/TailwindCSS",
      },
      {
        id: 4,
        desc: "Typescript",
      },
      {
        id: 5,
        desc: "And more",
      },
    ],
    backend: [
      {
        id: 1,
        desc: "Python",
      },
      {
        id: 2,
        desc: "Django/Django Rest Framework",
      },
      {
        id: 3,
        desc: "FastApi",
      },
      {
        id: 4,
        desc: "Version control; Git",
      },
      {
        id: 5,
        desc: "And more",
      },
    ],
  },
  projects: [
    {
      id: 5,
      img: "/assets/img/eato.png",
      demoLink: "https://eatonetwork.com/",
      title: "Eato",
      description: "A recipe website",
    },
    {
      id: 1,
      img: "/assets/img/blood-bank.png",
      demoLink: "https://github.com/lamepic/blood-bank-system/tree/main",
      title: "Blood Bank",
      description:
        "Blood bank management system to help manage every activity involving blood donation.",
    },
    {
      id: 2,
      img: "/assets/img/country-facts.png",
      demoLink: "https://countryfactss.web.app/",
      title: "Country Facts",
      description:
        "Beautiul website to help you learn small facts about countries around the world.",
    },
    {
      id: 6,
      img: "/assets/img/hangman.png",
      demoLink: "https://hangman-d638f.web.app/",
      title: "Hangman Game",
      description: "A fun hangman game, think you can win?",
    },
    {
      id: 3,
      img: "/assets/img/netflix-clone.png",
      demoLink: "https://netflix-clone-4fcfb.web.app/",
      title: "Netflix Clone",
      description:
        "A clone of the popular netflix website, but for watching trailers of your favorite movies.",
    },
    {
      id: 4,
      img: "/assets/img/todo-app.jpg",
      demoLink: "https://todo-app-5ba6b.web.app/",
      title: "Modern Todo-App",
      description:
        "Simple todo application with a beautiful UI to help you keep track of your daily tasks",
    },
  ],
  contact: {
    phone: "+233 54 596 8450",
    email: "richardarthur99@outlook.com",
    location: "United States",
  },
};

export const socialLinks = {
  github: "https://github.com/lamepic",
  twitter: "https://twitter.com/___nerd____",
  linkedIn: "https://linkedin.com/in/richard-arthur99",
};

export default data;
